import React from 'react';
import ContentLoader from 'react-content-loader';
import styled from '@emotion/styled';
import VisuallyHidden from '@reach/visually-hidden';

const defaultProps = {
  count: 1,
};

const ListWrapper = styled.ul({
  listStyle: 'none',
  textAlign: 'left',
  fontSize: '16px',
  padding: 0,
  margin: 0,
  marginTop: '30px',
  borderTop: '1px solid #E1E1E1',
});

const ListItem = styled.li({
  display: 'grid',
  gridTemplateColumns: '1fr',
  gridGap: '20px',
  alignItems: 'center',
  padding: '35px',
  borderBottom: '1px solid #E1E1E1',
});

const Skeleton = (props: typeof defaultProps): React.ReactElement => {
  const { count } = props;
  return (
    <ListWrapper>
      <VisuallyHidden>Skeleton</VisuallyHidden>
      {Array.from(Array(count).keys()).map((num: number) => (
        <ListItem key={num}>
          <ContentLoader
            speed={2}
            viewBox="0 0 100 12"
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
            title="Loading List"
            uniqueKey={`${num}`}
          >
            <circle cx="6" cy="6" r="6" />
            <rect x="17" y="1" rx="2" ry="2" width="50" height="4" />
            <rect x="17" y="7" rx="3" ry="3" width="37" height="4" />
          </ContentLoader>
        </ListItem>
      ))}
    </ListWrapper>
  );
};

Skeleton.defaultProps = defaultProps;

export default Skeleton;
